import React from 'react';
import DashboardLayout from '@/components/layout/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

function UserManagement() {
  return (
    <DashboardLayout>
      <div className="space-y-6 fade-in pt-2">
        <div>
          <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: 'Crimson Text, serif' }}>
            User Management
          </h1>
          <p className="text-gray-600">Manage system users and permissions</p>
        </div>

        <Card className="glass">
          <CardHeader>
            <CardTitle>Users List</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-500 text-center py-12">Feature in development</p>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
}

export default UserManagement;
